import { graphql } from "gatsby";
import { TooltipsBasic, TooltipsPlacement, TooltipsWithHtml } from "../../../../src/examples/components/ToolTips";
import * as React from 'react';
export default {
  graphql,
  TooltipsBasic,
  TooltipsPlacement,
  TooltipsWithHtml,
  React
};